import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify';
import '@mdi/font/css/materialdesignicons.css'
import Vuex from 'vuex'
import store from './store'

Vue.use(Vuex)
Vue.config.devtools = true
Vue.config.productionTip = false



Vue.directive('NoSpaceInput',
    {
        inserted: function(el) {//, _, vnode
    el.addEventListener('paste', async function(evt) {
        // event.preventDefault();
       // event.stopPropagation();

       // evt.clipboardData.getData('text') = evt.clipboardData.getData('text').replace(/ /g, "");
        // evt.target.value = evt.clipboardData.getData('text').replace(/ /g, "");

         return evt.clipboardData.getData('text').replace(/ /g, "");
       //  vnode.componentInstance.$emit('input', evt.clipboardData.getData('text').replace(/ /g, ""));



     })
}


    })




window.onload = function() {
    const start_page = new Vue({
        vuetify,
        store,
        render: h => h(App)
    }).$mount('#app')
    console.log(start_page);
}


